import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { DtoRoutesDefinition } from "../dto/auth.dto";
import { isAuthenticated } from "../redux/authSlice";
import { useAppSelector } from "../redux/hooks";
import AdminForm from "../../components/AdminComponents/AdminForm";
import AdminTable from "../../components/AdminComponents/AdminTable";
import VendorAdminTable from "../../components/AdminComponents/VendorAdminsTable";
import Login from "../../components/Login/Login";
import ResetPassword from "../../components/Login/ResetPassword";
import SetPassword from "../../components/Login/SetPassword";
import VendorForm from "../../components/VendorComponents/VendorForm";
import VendorTable from "../../components/VendorComponents/VendorTable";
import UserForm from "../../components/AdminComponents/UserForm";
import Settings from "../../components/AdminComponents/Settings";

const OpenRoutes: DtoRoutesDefinition[] = [
    // {path: 'not-found', element: <NotFound />},
];
const ProtectedRoutes: DtoRoutesDefinition[] = [
    {
        path: "/",
        element: <></>,
        redirectTo: "/customer",
    },
    {
        path: "/settings",
        element: <Settings />,
    },
    {
        path: "/super-admin",
        element: <AdminTable />,
    },
    {
        path: "/super-admin/create",
        element: <AdminForm />,
    },
    {
        path: "/super-admin/edit",
        element: <AdminForm />,
    },
    {
        path: "/customer-admin",
        element: <VendorAdminTable />,
    },
    {
        path: "/customer-admin/create",
        element: <UserForm />,
    },
    {
        path: "/customer-admin/edit",
        element: <UserForm />,
    },
    {
        path: "/customer",
        element: <VendorTable />,
    },
    {
        path: "/customer/create",
        element: <VendorForm />,
    },
    {
        path: "/customer/edit",
        element: <VendorForm />,
    },

];
const AuthRoutes: DtoRoutesDefinition[] = [
    { path: "/sign-in", element: <Login /> },
    { path: "/resetpassword", element: <ResetPassword /> },
    { path: "/setpassword", element: <SetPassword /> },
];

const UnAuthRouteMiddleware = () => {
    const location = useLocation();
    return (
        <Navigate to="/sign-in" state={{ locationFrom: location.pathname }} />
    );
};

const AuthRouteMiddleware = () => {
    const redirectUrl = "/customer";
    const location = useLocation();
    return (
        <Navigate
            to={redirectUrl}
            state={{ locationFrom: location.pathname }}
        />
    );
};

const ProtectedRouteMiddleware = (routeDefinition: {
    routeInfo: DtoRoutesDefinition;
}) => {
    const location = useLocation();
    if (routeDefinition.routeInfo.redirectTo) {
        return (
            <Navigate
                to={routeDefinition.routeInfo.redirectTo!}
                state={{ locationFrom: location.pathname }}
            />
        );
    }
    return routeDefinition.routeInfo.element;
};

export const AppRoutes = () => {
    const authenticated = useAppSelector(isAuthenticated);
    return (
        <Routes>
            {OpenRoutes.map((routeInfo) => (
                <Route
                    key={routeInfo.path}
                    path={routeInfo.path}
                    element={routeInfo.element}
                />
            ))}
            {ProtectedRoutes.map((routeInfo) => (
                <Route
                    key={routeInfo.path}
                    path={routeInfo.path}
                    element={
                        authenticated ? (
                            <ProtectedRouteMiddleware routeInfo={routeInfo} />
                        ) : (
                            <UnAuthRouteMiddleware />
                        )
                    }
                />
            ))}
            {AuthRoutes.map((routeInfo) => (
                <Route
                    key={routeInfo.path}
                    path={routeInfo.path}
                    element={
                        !authenticated ? (
                            routeInfo.element
                        ) : (
                            <AuthRouteMiddleware />
                        )
                    }
                />
            ))}
            <Route path="*" element={<Navigate replace to={"/customer"} />} />
        </Routes>
    );
};
